import { useTitle } from '@entities/page';

const PageTitle = () => {
  const title = useTitle();

  return <h1>{title}</h1>;
};

export default PageTitle;
